import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import { SegmentedController, SegmentedControllerPanel } from '@paypalcorp/pp-react';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import styles from './TypeConfigurator.module.less';
import { trackButtonChange } from '../../../lib/fpti';
import { valueToQueryParamMap } from '../ControlPanel/constants';

const TypeConfigurator = ({ content }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    integrationType: type,
    code: {
      language: { frontend, backend }
    }
  } = useContext(IntegrationPageSectionContext);

  const handleButtonClick = (index) => {
    const buttonName = 'IntegrationTypeButton';
    const value = content[index].id;
    trackButtonChange(buttonName, value);
    searchParams.set('type', value);
    searchParams.set('frontend', frontend);
    searchParams.set('backend', valueToQueryParamMap[backend] || backend);
    setSearchParams(searchParams);
    window.location.reload();
  };

  return (
    <div className={styles.container}>
      <SegmentedController
        name="TypeConfigurator"
        selectedTabIdx={content.findIndex((el) => el.id === type)}
        tabs={content}
        onClick={(_, index) => handleButtonClick(index)}
      >
        {content.map(({ id }) => (
          <SegmentedControllerPanel key={id} id={id}>
            <></>
          </SegmentedControllerPanel>
        ))}
      </SegmentedController>
    </div>
  );
};

export default TypeConfigurator;

TypeConfigurator.propTypes = {
  content: PropTypes.array
};

TypeConfigurator.defaultProps = { content: [] };
